import { FC } from 'react';
import classNames from 'classnames';
import { BodyText, Eyebrow, Stack } from '@servicetitan/design-system';

interface DetailItemProps {
    name: string;
    value?: string | number | null;
    textClassName?: string;
}

export const DetailsItem: FC<DetailItemProps> = ({ name, value, textClassName }) => {
    const displayValue = value?.toString() || '-';

    return (
        <Stack direction="column">
            <Eyebrow className="m-b-half">{name}</Eyebrow>
            <BodyText className={classNames('t-truncate', textClassName)}>{displayValue}</BodyText>
        </Stack>
    );
};
